export default "__VITE_ASSET__OAGh9gxl__"